"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsBase = require("@telus-uds/components-base");
var _NavigationItem = _interopRequireDefault(require("./NavigationItem"));
var _useOverlaidPosition = _interopRequireDefault(require("../utils/useOverlaidPosition"));
var _resolveItemSelection = _interopRequireDefault(require("./resolveItemSelection"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * A NavigationItem that opens or closes a Listbox of other NavigationItems.
 *
 * This is rendered automatically by `NavigationBar` and isn't intended be used directly.
 */const NavigationSubMenu = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    children,
    id,
    isOpen = false,
    tokens = {},
    label,
    onClick,
    selectedId,
    items = [],
    openOverlayRef,
    LinkRouter,
    linkRouterProps,
    itemsContainerRef
  } = _ref;
  const focusTrapRef = _react.default.useRef();
  const maxWidth = 289; // Slightly over 288 of nav item to account for subpixel rounding
  const defaultOffsets = {
    offsets: {
      vertical: 4
    }
  };
  const {
    align,
    offsets,
    minWidth
  } = (0, _componentsBase.useResponsiveProp)({
    xs: {
      ...defaultOffsets,
      align: {
        top: 'bottom',
        left: 'left'
      },
      minWidth: maxWidth
    },
    sm: {
      ...defaultOffsets,
      align: {
        top: 'bottom',
        right: 'right'
      },
      minWidth: maxWidth
    },
    lg: {
      ...defaultOffsets,
      align: {
        top: 'bottom',
        center: 'center'
      },
      minWidth: 192
    }
  });
  const {
    overlaidPosition,
    sourceRef,
    targetRef,
    onTargetLayout,
    isReady
  } = (0, _useOverlaidPosition.default)({
    isShown: isOpen,
    offsets,
    align
  });
  const {
    selected
  } = (0, _resolveItemSelection.default)({
    id,
    label,
    items
  }, selectedId);
  const handleClick = event => {
    if (typeof onClick === 'function') onClick(event);
  };
  const {
    icoMenu
  } = (0, _componentsBase.useThemeTokens)('NavigationBar', tokens, {}, {
    expanded: isOpen
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_NavigationItem.default, {
      ref: sourceRef,
      accessibilityRole: "button",
      id: id,
      selected: selected,
      onClick: handleClick,
      icon: icoMenu,
      tokens: tokens,
      children: _ref2 => {
        let {
          textStyles
        } = _ref2;
        return [children, /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.Icon, {
          icon: icoMenu,
          variant: {
            size: 'micro'
          },
          tokens: {
            color: textStyles[0]?.color
          }
        }, `${id}_icon`)];
      }
    }), isOpen && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.Listbox.Overlay, {
        overlaidPosition: overlaidPosition,
        maxWidth: maxWidth,
        minWidth: minWidth,
        isReady: isReady,
        onLayout: onTargetLayout,
        ref: openOverlayRef,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.Listbox, {
          items: items,
          firstItemRef: targetRef,
          parentRef: sourceRef,
          selectedId: selectedId,
          LinkRouter: LinkRouter,
          linkRouterProps: linkRouterProps,
          ref: itemsContainerRef || ref
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        // This catches and shifts focus to other interactive elements.
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: 0,
        ref: focusTrapRef,
        onFocus: () => targetRef.current.focus()
      })]
    })]
  });
});
NavigationSubMenu.displayName = 'NavigationSubMenu';

// @TODO - proper prop types and comments
NavigationSubMenu.propTypes = {
  tokens: (0, _componentsBase.getTokensPropType)('NavigationBar'),
  children: _propTypes.default.node,
  id: _propTypes.default.string,
  isOpen: _propTypes.default.bool,
  label: _propTypes.default.string,
  onClick: _propTypes.default.func,
  selectedId: _propTypes.default.string,
  items: _propTypes.default.array,
  openOverlayRef: _propTypes.default.object,
  LinkRouter: _propTypes.default.elementType,
  linkRouterProps: _propTypes.default.object,
  itemsContainerRef: _propTypes.default.object
};
var _default = exports.default = NavigationSubMenu;